/**
 * Sign-up terms agreement — shared defaults.
 *
 * Both the storefront register form and the admin editor for it need these,
 * and they live here rather than on either page so importing one doesn't drag
 * the other's whole bundle along.
 *
 * Overridable per deployment from Growth → Customer Accounts, so a white-label
 * store can name its own agreement without touching code. Whether acceptance
 * is required is not configurable: the API rejects a registration without it.
 */
export const DEFAULT_TERMS_CONSENT = 'I have read and agree to the'
export const DEFAULT_TERMS_LABEL   = 'Terms of Service'
